<template>
  <div>
    <div v-loading='loading' style="background:#fff;padding-bottom:40px">
      <div ref="print" id="ImageExportDom" style="margin-top:-20px">
        <div>
          <h3 class="title">{{invoice.statements_type==2?'MCN发票申请单':'开具发票申请单'}}<br /><span style="font-size: 14px;line-height: 20px;font-weight: initial;">{{invoice.company}}</span></h3>
          <div class="bothSides statementsID" v-if="invoice.id">（04之前）发票序列号：{{invoice.id}}</div>
          <div class="bothSides statementsID" style="top:55px" v-if="invoice.statements_id">（04之前）结算单序列号：{{invoice.statements_id}}</div>
          <div style="text-align:right;margin:0 24px 10px">
            <span v-if="invoice.status == 1" style="color:#EF7400">待商务审核</span>
            <span v-if="invoice.status == 2" style="color:#3265f3">待财务审核</span>
            <span v-if="invoice.status == 3" style="color:#d51313;">商务审核驳回</span>
            <span v-if="invoice.status == 4" style="color:#00BB5D;">财务审核通过</span>
            <span v-if="invoice.status == 5" style="color:#d51313;">财务审核驳回</span>
          </div>
          <table border="1" class="tabel" bordercolor="#ebeef4">
            <tr style="background:#F8F8FA">
              <td colspan='2' class="label">客户名称：</td>
              <td colspan='2'>{{invoice.customer_name}}</td>
              <td class="label">申请日期:</td>
              <td>{{invoice.applicant_time}}</td>
              <td class="label">申请人：</td>
              <td>{{invoice.applicant}}</td>
            </tr>
            <tr>
              <td class="label">编号</td>
              <td class="label">消耗月份</td>
              <td class="label">项目名称</td>
              <td class="label">开票金额</td>
              <td class="label">发票类型</td>
              <td class="label">发票服务名称</td>
              <td colspan='2' class="label" style="width:30%">发票备注</td>
            </tr>
            <tr v-for="(item,index) in order_list" :key="index">
              <td>{{index+1}}</td>
              <td>{{item.month}}</td>
              <td>{{item.project_name}}</td>
              <td>{{$formatNum(item.invoice_amount)}}</td>
              <td>{{item.invoice_type == 1 ? '增值税专用发票' : item.invoice_type == 2 ? '增值税普通发票' : ''}}</td>
              <td>{{item.service_type}}</td>
              <td colspan='2'>{{item.invoice_note}}</td>
            </tr>
            <tr>
              <td colspan='3'>金额合计</td>
              <td>{{$formatNum(invoice.invoice_amount)}}</td>
              <td></td>
              <td></td>
              <td colspan='2'></td>
            </tr>
            <tr>
              <td colspan='2' class="label label1">开票信息</td>
              <td colspan='6'></td>
            </tr>
            <tr>
              <td colspan='2' class="label label1">名称：</td>
              <td colspan='6' class="con">{{invoice.title}}</td>
            </tr>
            <tr>
              <td colspan='2' class="label label1">税号：</td>
              <td colspan='6' class="con" v-if="editFlag">
                <el-input class="input" type="textarea" v-model="invoice.tax_id" size='mini' placeholder="请输入税号"></el-input>
              </td>
              <td colspan='6' class="con" v-else>{{invoice.tax_id}}</td>
            </tr>
            <tr>
              <td colspan='2' class="label label1">地址/电话：</td>
              <td colspan='6' class="con" v-if="editFlag">
                <el-input class="input" type="textarea" v-model="invoice.address_tel" size='mini' placeholder="请输入地址/电话"></el-input>
              </td>
              <td colspan='6' class="con" v-else>{{invoice.address_tel}}</td>
            </tr>
            <tr>
              <td colspan='2' class="label label1">银行/账号：</td>
              <td colspan='6' class="con" v-if="editFlag">
                <el-input class="input" type="textarea" v-model="invoice.bank_account" size='mini' placeholder="请输入银行/账号"></el-input>
              </td>
              <td colspan='6' class="con" v-else>{{invoice.bank_account}}</td>
            </tr>
            <tr>
              <td colspan='2' class="label label1">收件人：</td>
              <td colspan='6' class="con" v-if="editFlag">
                <el-input class="input" type="textarea" v-model="invoice.consignee" size='mini' placeholder="请输入收件人"></el-input>
              </td>
              <td colspan='6' class="con" v-else>{{invoice.consignee}}</td>
            </tr>
            <tr>
              <td colspan='2' class="label label1">联系人：</td>
              <td colspan='6' class="con" v-if="editFlag">
                <el-input class="input" type="textarea" v-model="invoice.contacts" size='mini' placeholder="请输入联系人"></el-input>
              </td>
              <td colspan='6' class="con" v-else>{{invoice.contacts}}</td>
            </tr>
            <tr>
              <td colspan='2' class="label label1">联系方式：</td>
              <td colspan='6' class="con" v-if="editFlag">
                <el-input class="input" type="textarea" v-model="invoice.contact_number" size='mini' placeholder="请输入联系方式"></el-input>
              </td>
              <td colspan='6' class="con" v-else>{{invoice.contact_number}}</td>
            </tr>
            <tr>
              <td colspan='2' class="label label1">邮寄地址：</td>
              <td colspan='6' class="con" v-if="editFlag">
                <el-input class="input" type="textarea" v-model="invoice.mail_address" size='mini' placeholder="请输入邮寄地址"></el-input>
              </td>
              <td colspan='6' class="con" v-else>{{invoice.mail_address}}</td>
            </tr>
            <tr>
              <td colspan='2' class="label label1">开票说明：</td>
              <td colspan='6' class="con" v-if="editFlag">
                <el-input class="input" type="textarea" v-model="invoice.note" size='mini' placeholder="请输入开票说明"></el-input>
              </td>
              <td colspan='6' class="con" v-else style="max-width:300px">{{invoice.note}}</td>
            </tr>
          </table>
        </div>
        <div v-if="uploadFile.length!=0">
          <div v-for="(item,index) in uploadFile" :key="index">
            <div class="enclosure" @click="lookFile(item)">
              <i class="el-icon-search"></i>
              <span>{{item&&item.split('/')&&item.split('/')[item.split('/').length-1]?item.split('/')[item.split('/').length-1]:'附件'}}</span>
            </div>
            <div class="enclosure" @click="downLoadFiles(item)">
              <i class="el-icon-download"></i>
              <span>下载附件</span>
            </div>
          </div>
        </div>
        <div class="verify_opinion no-print" v-if="editFlag">
          <add-file @file='(val)=>{uploadFile=val}' :fileOtherList='fileList' :uploadOtherFile='uploadFile'></add-file>
        </div>
        <div class="examine">
          <div v-if="invoice.status&&invoice.status!=1" style="margin:5px 0">
            <div style="margin:5px 0">
              <label>商务审核人：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{invoice.verify_user}}</span>
            </div>
            <div style="margin:5px 0">
              <label>商务审核时间：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{invoice.verify_at}}</span>
            </div>
            <div style="margin:5px 0">
              <label>商务审核备注：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{invoice.verify_note}}</span>
            </div>
          </div>
          <div v-if="invoice.status==4||invoice.status==5" style="margin:5px 0">
            <div style="margin:5px 0">
              <label>财务审核人：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{invoice.confirm_verify_user}}</span>
            </div>
            <div style="margin:5px 0">
              <label>财务审核时间：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{invoice.confirm_verify_at}}</span>
            </div>
            <div style="margin:5px 0">
              <label>财务审核备注：</label>
              <span style="color:#5E5F6B;font-size:14px;">{{invoice.confirm_verify_note}}</span>
            </div>
          </div>
          <div style="margin:5px 0" class="no-print" v-if="(userInfo.role_id == 15 && invoice.status == 1) || (userInfo.role_id == 10 && invoice.status == 2)">
            <label style="vertical-align: top;">审核备注：</label>
            <el-input class="textarea" type="textarea" placeholder="请输入审核原因" v-model="reason">
            </el-input>
          </div>
        </div>
      </div>
      <div slot="footer" style="text-align: center;margin-top:40px">
        <div v-if="userInfo.role_id==15" style="display:inline-block">
          <el-button type="primary" size='small' @click="editStatement(2)" v-if="invoice.status==1">审核通过</el-button>
          <el-button type="primary" size='small' @click="editStatement(3)" style="background:#d51313;border-color:#d51313" v-if="invoice.status==1">审核不通过</el-button>
        </div>
        <div v-else-if="userInfo.role_id==10" style="display:inline-block">
          <el-button type="primary" size='small' @click="editStatement(4)" v-if="invoice.status==2">审核通过</el-button>
          <el-button type="primary" size='small' @click="editStatement(5)" style="background:#d51313;border-color:#d51313" v-if="invoice.status==2">审核不通过</el-button>
        </div>
        <div v-else style="display:inline-block">
          <el-button type="primary" size='small' v-if="invoice.status==5||invoice.status==3" @click="editInvoice">提 交</el-button>
        </div>
        <el-button size='mini' @click="printDOM">导出</el-button>
        <el-button size='mini' @click="cancelToast">取消</el-button>
      </div>
      <!-- <look-file v-if="lookFlag" :fileUrl='fileUrl' @close="()=>{lookFlag=false}"></look-file> -->
    </div>
  </div>
</template>
<script>
import addFile from '@/components/assembly/addFile'
// import lookFile from '@/components/assembly/lookFile'
export default {
  components: {
    // lookFile,
    addFile
  },
  props: ['invoice_id'],
  data () {
    return {
      loading: false,
      invoice: {},
      fileType: '',
      csvTh: [],
      csvData: [],
      lookFlag: false,
      file_url: '',
      userInfo: {},
      fileList: [],
      uploadFile: [],
      reason: '',
      id: this.invoice_id,
      routeName: '',
      fileUrl: '',
      editFlag: false,
      order_list: []
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    this.getInvoice()
  },
  methods: {
    cancelToast () {
      this.$emit('cancelToast')
    },
    editStatement (status) {//提交
      if ((status == 3 || status == 5) && (!this.reason || this.reason == '')) {
        this.$message({
          message: '请输入审核原因',
          type: 'warning'
        })
        return
      }
      this.loading = true;
      this.$axios.post(this.URL.BASEURL + this.URL.customerInvoicesComplement_verify, {
        id: this.id,
        status: status,
        verify_note: this.reason
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.$emit('emit_refresh')
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getInvoice () {
      this.loading = true;
      this.$axios.get(this.URL.BASEURL + this.URL.customerInvoicesComplement_detail, {
        params: {
          id: this.id
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          var data = res.rst;
          this.invoice = res.rst.invoice;
          this.order_list = data.order_list
          if (this.userInfo.role_id == 15 || this.userInfo.role_id == 10 || (this.invoice.status == 1 || this.invoice.status == 2 || this.invoice.status == 4)) {
            this.editFlag = false
          } else {
            this.editFlag = true
          }
          this.uploadFile = this.invoice.files ? this.invoice.files : []
          this.fileList = [];
          if (this.invoice.files) {
            this.invoice.files.forEach((item, index) => {
              this.fileList.push({ name: item && item.split('/') && item.split('/')[item.split('/').length - 1] ? item.split('/')[item.split('/').length - 1] : '附件', url: item })
            });
          }
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    editInvoice () {//发票编辑
      if (!this.uploadFile || this.uploadFile.length == 0) {
        this.$message({
          message: '请提交附件',
          type: 'warning'
        })
        return
      }
      this.loading = true;
      this.$axios.post(this.URL.BASEURL + this.URL.customerInvoicesComplement_update, {
        id: this.id,
        tax_id: this.invoice.tax_id,
        address_tel: this.invoice.address_tel,
        bank_account: this.invoice.bank_account,
        consignee: this.invoice.consignee,
        contacts: this.invoice.contacts,
        contact_number: this.invoice.contact_number,
        mail_address: this.invoice.mail_address,
        note: this.invoice.note,
        files: this.uploadFile
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.$emit('emit_refresh')
        } else {
          this.loading = false;
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    printDOM () {
      this.getPdf({ title: this.invoice.statements_type == 2 ? 'MCN发票申请单' : '开具发票申请单', noScrollBar: true, invoice: true })
      // document.title = '新媒体事业部消耗表系统'
      // this.$print(this.$refs.print)
    },
    lookFile (data) {//查看文件
      this.fileUrl = data;
      // this.lookFlag = true
      let routeData = this.$router.resolve({
        path: '/lookFile?url=' + this.fileUrl,
      })
      this.$winopen(routeData.href)
    },
    downLoadFiles (data) {//下载
      var url = data.replace("http://", window.location.protocol + '//');
      var doc_name = (url.split('/'))[url.split('/').length - 1]
      this.ajax(url, (xhr) => {
        this.downloadFile(xhr.response, doc_name)
      }, {
        responseType: 'blob'
      })
    },
    downloadFile (content, filename) {
      var a = document.createElement('a')
      var blob = new Blob([content])
      var url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = filename
      a.click()
      window.URL.revokeObjectURL(url)
    },
    ajax (url, callback, options) {
      window.URL = window.URL || window.webkitURL
      var xhr = new XMLHttpRequest()
      xhr.open('get', url, true)
      if (options.responseType) {
        xhr.responseType = options.responseType
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          callback(xhr)
        }
      }
      xhr.send()
    },
  }
}
</script>
<style lang="scss" scoped>
@import "../../newBilling/invoice/invoiceDetail.scss";
</style>
<style lang="scss">
#PrintingBox {
  .el-table--scrollable-y .el-table__body-wrapper {
    height: 100% !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/BeforeApril/invoice/invoiceDetail.vue